import { Box, Typography, Button } from "@mui/material";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import makeAPIRequest from "../global/apiCall";
import { LOGIN, POST } from "../global/apiKeys";
import { FcGoogle } from "react-icons/fc";

function Splash() {
  const navigate = useNavigate();

  const makeLoginRequest = (accessToken) => {
    const obj = {
      token: accessToken,
    };

    makeAPIRequest(POST, LOGIN, obj)
      .then((res) => {
        localStorage.setItem("idToken", JSON.stringify(res?.data));
        navigate("/dashboard");
      })
      .catch((err) => {});
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      makeLoginRequest(tokenResponse?.access_token);
    },
    onError: () => {
      console.error("Login Failed");
    },
  });

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: `radial-gradient(circle, rgba(84,177,205,1) 0%, rgba(34,130,185,1) 100%)`,
        color: "#fff",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          backgroundColor: "#fff",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          marginBottom: 6,
        }}
      >
        <img width={200} src="/images/Frame_2.png" alt="App Logo" />
      </Box>

      <Typography variant="h3" sx={{ fontWeight: "bold" }}>
        Business
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "300", marginBottom: 8 }}>
        MySocialBizScan
      </Typography>

      <Button
        variant="outlined"
        onClick={() => {
          login();
        }}
        startIcon={<FcGoogle />}
        sx={{
          textTransform: "none",
          fontSize: "16px",
          fontWeight: 500,
          color: "#5F6368",
          padding: "8px 16px",
          border: "1px solid #ddd",
          borderRadius: "10px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        Login with Google
      </Button>

      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          textAlign: "center",
          fontSize: "14px",
          opacity: 0.8,
        }}
      >
        <Typography variant="body2">Powered By</Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Mavani Enterprise Solutions
        </Typography>
      </Box>
    </Box>
  );
}

export default Splash;
